import AWSRDSRunningHoursReport from '~/admin/aws_rds_running_hours_report'
import ReactController from '~/controllers/react_controller'

export default class AWSRDSRunningHoursReportController extends ReactController {
  static values = {
    organizations: Array,
    selectedOrganizationId: String,
    selectedLinkedAccount: String,
  }

  createComponent() {
    return (
      <AWSRDSRunningHoursReport
        organizations={this.organizationsValue}
        selectedOrganizationId={this.selectedOrganizationIdValue}
        selectedLinkedAccount={this.selectedLinkedAccountValue}
      />
    )
  }
}
